module.exports = __webpack_public_path__ + "static/media/broker-gym-marker-selected.be9c2d4f.svg";